module.exports = "<ul class=\"pagination-b no-p no-m\">\n    <li ng-click=\"$ctrl.click(page)\" ng-repeat=\"page in $ctrl.pages\" ng-class=\"{'active': page.active}\">\n        <a href=\"#\" class=\"link\">{{ page.label }}</a>\n    </li>\n </ul>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/shared/ui/pagination/pagination.html
// module id = 515
// module chunks = 0